eliminarSuministro = function(e){
    var data = e.dataset;
    $("#form_eliminar_suministro")[0].reset();
    $("#eliminar_suministro_id").val(data.id);
    $("#eliminar_suministro_nombre").html(`¿Deseas eliminar el suministro <strong>${data.nombre}</strong>?`);
}